'use strict';
import $ = require('jquery');

export class recruitLine {
    constructor() {
        if ($('.bulletRecruitLine').length === 0) return;

        const targets = document.querySelectorAll('.bulletRecruitLine');
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.setAttribute('data-is-active', 'true');
                }
            });
        }, {
            root: null,
            threshold: 0,
            rootMargin: '-50% 0px',
        });

        targets.forEach(target => {
            observer.observe(target);
        })

        line();
        window.addEventListener('resize',line);

        function line() {
            const items = $('.bulletRecruitLine');
            items.each(function (i, item) {
                const path = $(this).find('path')[0] as unknown as SVGPathElement;
                $(this).css('--length', `${path.getTotalLength()}px`);
            });
        }
    }
}

export default recruitLine;